import { useSquashGameState } from '@src/providers/squashGameState';
import { Route as completed_route } from '../routes/game/completedSquash';
import { useNavigate } from '@tanstack/react-router';
import { HStack, Link } from 'ui_2';
import { BiHistory } from 'react-icons/bi';

export const SquashHistoryButton = () => {
  const { inactiveSquashes } = useSquashGameState();

  const navigate = useNavigate();

  if (inactiveSquashes && inactiveSquashes.length > 0) {
    return (
      <HStack
        className='right-0 z-50 h-[35px] w-[35px] cursor-pointer rounded-full border border-gray-100 bg-gray-50 p-2 transition-colors duration-300 hover:bg-white active:bg-gray-200'
        onClick={() => navigate({ to: completed_route.to })}
      >
        <BiHistory />
      </HStack>
    );
  }
};

export const SquashHistoryButtonLarge = () => {
  const { inactiveSquashes } = useSquashGameState();

  const navigate = useNavigate();

  if (inactiveSquashes && inactiveSquashes.length > 0) {
    return (
      <Link
        onClick={() => navigate({ to: completed_route.to })}
        variant='black'
      >
        View History
      </Link>
    );
  }
};
